import { useState, useCallback, useEffect } from "react";
import _ from "lodash";
import TableNameList from "./table";
import { Col, Row, Form, Card, Input, Space, Tooltip, Empty } from "antd";
import { SUCCESS_CODE } from "../../../../lib/const";
import { getListIndicatorByYear } from "../../../../services/progressPerformance";

const YearlyTab = ({ year }) => {
  const [isUpdate, setIsUpdate] = useState(false);
  const [data, setData] = useState([]);

  const convertDataList = async (dataList) => {
    const result = dataList.reduce((acc, item) => {
      const {
        yearOfBudget,
        projectId,
        projectNameEn,
        projectNameTh,
        indicatorId,
        indicatorNameEn,
        indicatorNameTh,
        departmentId,
        departmentNameEn,
        departmentNameTh,
        divisionId,
        divisionNameEn,
        divisionNameTh,
        id,
      } = item;
      const yearIndex = acc.findIndex((x) => x.yearOfBudget === yearOfBudget);
      if (yearIndex === -1) {
        let object = {
          yearOfBudget,
          indicators: [
            {
              id,
              indicatorId,
              indicatorNameEn,
              indicatorNameTh,
              projects: [
                {
                  projectId,
                  projectNameEn,
                  projectNameTh,
                  departmentId,
                  departmentNameEn,
                  departmentNameTh,
                  divisionId,
                  divisionNameEn,
                  divisionNameTh,
                },
              ],
            },
          ],
        };

        // form.setFieldsValue(object);
        acc.push(object);
      } else {
        const indicatorIndex = acc[yearIndex].indicators.findIndex(
          (x) => x.indicatorId === indicatorId
        );
        if (indicatorIndex === -1) {
          let object = {
            id,
            indicatorId,
            indicatorNameEn,
            indicatorNameTh,
            projects: [
              {
                projectId,
                projectNameEn,
                projectNameTh,
                departmentId,
                departmentNameEn,
                departmentNameTh,
                divisionId,
                divisionNameEn,
                divisionNameTh,
              },
            ],
          };
          // form.setFieldsValue(object);
          acc[yearIndex].indicators.push(object);
        } else {
          let object = {
            projectId,
            projectNameEn,
            projectNameTh,
            departmentId,
            departmentNameEn,
            departmentNameTh,
            divisionId,
            divisionNameEn,
            divisionNameTh,
          };
          acc[yearIndex].indicators[indicatorIndex].projects.push(object);
        }
      }
      return acc;
    }, []);

    return result;
  };

  const fetchIndicatorById = useCallback(async () => {
    // call project api by year and id
    const res = await getListIndicatorByYear({
      year: year,
      indicatorId: "",
    });
    if (res.data.code === SUCCESS_CODE) {
      const { objectValue } = res.data;
      const convert = await convertDataList(objectValue);

      setData(_.get(convert[0], "indicators"));
    }
  }, [setData]);

  useEffect(() => {
    fetchIndicatorById();
  }, [fetchIndicatorById]);

  return (
    <Form onFinish={() => {}} layout="vertical" autoComplete="off">
      {/* <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
        <Col span={24} align="right">
          <Space>
            <Button>ยกเลิก</Button>
            {isUpdate == false ? (
              <Button type="primary" htmlType="submit">
                บันทึก
              </Button>
            ) : (
              <Button type="primary">แก้ไข</Button>
            )}
          </Space>
        </Col>
      </Row> */}

      {data ? (
        data.map((item) => (
          <Row gutter={[16, 8]} className="card" style={{ marginBottom: 10 }}>
            <Col span={24} style={{ padding: 0 }}>
              <Form.Item label="ชื่อตัวชี้วัด">
                {item?.indicatorNameTh ? item.indicatorNameTh : "-"}
              </Form.Item>
            </Col>
            <Col span={24} style={{ padding: 0 }}>
              <TableNameList
                dataSource={item.projects}
                canEdit={false}
                canView={true}
              />
            </Col>
          </Row>
        ))
      ) : (
        <Empty />
      )}
    </Form>
  );
};

export default YearlyTab;
